module.exports = __webpack_public_path__ + "img/op11.78d21e49.png";